<template>
  <span>
    <el-link @click="open" type="primary" :underline="underline" :class="fs">
      {{label}}
    </el-link>
    <el-link v-if="openNewTab" :href="calculatedPath" target="_blank" type="primary" :underline="false" class="no-print">
      <i class="mdi mdi-launch ml-10"></i>
    </el-link>
  </span>
</template>
<script>
export default {
	name: 'Portaus-link',
  props: {
    path : String,
    id : Number,
    label : String,
    underline : {
      type : Boolean,
      default : false
    },
    primary : {
      type : String,
      default : 'primary'
    },
    fs : {
      type : String,
      default : 'fs-14'
    },
    openNewTab : {
      type : Boolean,
      default : true
    },
    type : {
      type : String
    }
  },
	data() {
		return {
		}
	},
  computed: {
    calculatedPath(){
      if (this.id == null) return null;
      let type  = this.type;
      if(type!= null ){
        if (type === 'CREDIT_NOTE') {
          type = 'credit-notes'
        }
        return"/"+type+"/".concat(this.id.toString());
      }
      return this.path.concat(this.id.toString());

    }
  },
	methods: {
    open(){
      var index=this.calculatedPath;
      this.$router.push(index);
    }
  },
  mounted() {

  }
}
</script>
<style>
</style>
